import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './ui/Button';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const isNearBottom = window.innerHeight + scrollY >= document.body.offsetHeight - 800;
      // Hide once the pricing/offer section (#checkout) is 20% visible
      const checkoutEl = document.getElementById('checkout');
      let isPastOffer = false;
      if (checkoutEl) {
        const rect = checkoutEl.getBoundingClientRect();
        const twentyPercent = rect.height * 0.2;
        // Section is 20% visible when its top is above (viewport bottom - 20% of section height)
        isPastOffer = rect.top <= window.innerHeight - twentyPercent;
      }
      if (scrollY > 500 && !isNearBottom && !isPastOffer) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-144">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-0 left-0 right-0 p-4 bg-dark/90 backdrop-blur-md border-t border-dark-border z-50 md:hidden" data-id="element-145">
          <Button href="#checkout" className="w-full py-4 text-lg shadow-lg" data-id="element-146">
            Get Instant Access
          </Button>
        </motion.div>}
    </AnimatePresence>;
}